module.exports = __webpack_public_path__ + "img/Icon ionic-logo-whatsapp.8a3d33ef.svg";